module.exports = __webpack_public_path__ + "img/listado.37378ec5.png";